import { trackEvent } from '@vp/om-newrelic-tracker';
import { createTrackingEventData } from './newRelicTrackingUtils';

// Customer feedback request events
const CUSTOMER_FEEDBACK_SUBTYPE = 'orders-ui-customer-feedback-request';

// Design feedback request events
const DESIGN_FEEDBACK_PAGE_SUBTYPE = 'design-page';
const DESIGN_FEEDBACK_BANNER_SUBTYPE = 'design-banner';
const DESIGN_FEEDBACK_REQUEST_PAGE_VIEWED = `${CUSTOMER_FEEDBACK_SUBTYPE}-${DESIGN_FEEDBACK_PAGE_SUBTYPE}-viewed`;
const DESIGN_FEEDBACK_REQUEST_BANNER_PRESENTED = `${CUSTOMER_FEEDBACK_SUBTYPE}-${DESIGN_FEEDBACK_BANNER_SUBTYPE}-presented`;
const DESIGN_FEEDBACK_REQUEST_BANNER_REDIRECT_LINK_CLICKED = `${CUSTOMER_FEEDBACK_SUBTYPE}-${DESIGN_FEEDBACK_BANNER_SUBTYPE}-redirect-link-clicked`;

/**
 * A shopper has viewed the design feedback request page
 */
export const trackDesignFeedbackPageViewed = (
  shopperId: string = '',
  pageName: string = '',
  additionalData: object = {}
) => {
  const trackingEventAdditionalData = {
    ...additionalData,
    pageName,
  };
  const eventData = createTrackingEventData(
    DESIGN_FEEDBACK_REQUEST_PAGE_VIEWED,
    shopperId,
    trackingEventAdditionalData
  );
  trackEvent(eventData);
};

/**
 * A shopper was presented the design feedback request banner
 */
export const trackDesignFeedbackBannerPresented = (
  shopperId: string = '',
  groupId: string = '',
  feedbackRequestId: string = '',
  additionalData: object = {}
) => {
  const trackingEventAdditionalData = {
    ...additionalData,
    groupId,
    feedbackRequestId,
  };
  const eventData = createTrackingEventData(
    DESIGN_FEEDBACK_REQUEST_BANNER_PRESENTED,
    shopperId,
    trackingEventAdditionalData
  );
  trackEvent(eventData);
};

/**
 * A shopper clicked the link in the design feedback request banner
 */
export const trackDesignFeedbackBannerRedirectLinkClicked = (
  shopperId: string = '',
  groupId: string = '',
  feedbackRequestId: string = '',
  additionalData: object = {}
) => {
  const trackingEventAdditionalData = {
    ...additionalData,
    groupId,
    feedbackRequestId,
  };
  const eventData = createTrackingEventData(
    DESIGN_FEEDBACK_REQUEST_BANNER_REDIRECT_LINK_CLICKED,
    shopperId,
    trackingEventAdditionalData
  );
  trackEvent(eventData);
};
